import { useLocation } from 'react-router-dom';

/**
 * useQuery hook to return the URL query
 *
 * @returns {object}
 */
export default function useQuery(): Record<string, string> {
    const location = useLocation();

    if (!location.search) {
        return {};
    }

    return location.search
        .slice(1)
        .split('&')
        .reduce((acc, curr) => {
            const [key, value] = curr.split('=');
            acc[key] = value;
            return acc;
        }, {});
}
